// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-body[data-v-78a1cafd] {\n  min-width: 25% !important;\n}\n.small-chat-body[data-v-78a1cafd] {\n  max-width: 70% !important;\n  height: 100%;\n}\n\n", ""]);
// Exports
module.exports = exports;
